import { parseNumeroItaliano } from "./numero_utils";

// Calcolo condiviso della % di diluizione di un fitofarmaco nella miscela di
// trattamento (usato sia nel dialog "Nuovo Evento" per il riscontro in
// tempo reale mentre si compila, sia nella lista eventi per mostrare il dato
// sugli eventi già salvati).
//
// % diluizione = quantità di prodotto impiegata / volume d'acqua totale * 100
// Numericamente coincide con la dose per ettolitro (g o mL per hL), l'unità
// più comune sulle etichette dei fitofarmaci, dato che 1 hL = 100 L.
export function calcolaPercentualeDiluizione(qta, volumeAcqua) {
  let q = parseNumeroItaliano(qta);
  let v = parseNumeroItaliano(volumeAcqua);
  if (!v || v <= 0 || isNaN(q)) {
    return null;
  }
  return (q / v) * 100;
}
